(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial"] && !Shopify.designMode) return;
  try {
    
          document.querySelectorAll('.testimonial-item').forEach((item) => {
          const video = item.querySelector('video');
          const button = item.querySelector('.play-pause-button');
          const playState = button?.querySelector('.play-state');
          const pauseState = button?.querySelector('.pause-state');
          const iconWrapper = button?.querySelector('.icon-wrapper');

          if (!video || !button) return;
          iconWrapper?.setAttribute('title', 'Pause');

          button.addEventListener('click', () => {
            if (video.paused) {
              video.play();
              iconWrapper?.setAttribute('title', 'Pause');
              playState.removeAttribute('hidden');
              pauseState.setAttribute('hidden', '');
            } else {
              video.pause();
              iconWrapper?.setAttribute('title', 'Play');
              pauseState.removeAttribute('hidden');
              playState.setAttribute('hidden', '');
            }
          });
        });
      
  } catch(e) { console.error(e); }
})();
})();
